import { Chip, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { isArray, isString } from "lodash";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
        background: "transparent",
        border: 0,
        boxShadow: "none",
    },
    field: {
        "& .MuiOutlinedInput-root": {
            minHeight: 38,
            borderRadius: 8,
            color: theme.mode === "light" ? "#172033" : "#f8fafc",
            backgroundColor: theme.mode === "light" ? "#ffffff" : "#2f2f2f",
            "& fieldset": {
                borderColor: theme.mode === "light" ? "#d7e1ee" : "rgba(255,255,255,0.10)",
                borderWidth: 1,
            },
            "&:hover fieldset": {
                borderColor: theme.mode === "light" ? "#cbd5e1" : "rgba(255,255,255,0.18)",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.mode === "light" ? "#cbd5e1" : "rgba(255,255,255,0.18)",
                borderWidth: 1,
            },
        },
        "& .MuiInputBase-input::placeholder": {
            color: theme.mode === "light" ? "#64748b" : "#cbd5e1",
            opacity: 1,
        },
    },
    tag: {
        color: "#FFF",
        marginRight: 4,
        padding: 1,
        fontWeight: "bold",
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 6,
        fontSize: "0.8em",
        whiteSpace: "nowrap",
        border: 0,
    },
    optionsPaper: {
        width: 400,
        marginLeft: 6,
        background: theme.mode === "light" ? "#ffffff" : "#343434",
        color: theme.mode === "light" ? "#172033" : "#f8fafc",
    },
}));

export function TagsContainer({ contact }) {
    const classes = useStyles();

    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        if (isMounted.current) {
            loadTags().then(() => {
                if (Array.isArray(contact.tags)) {
                    setSelecteds(contact.tags);
                } else {
                    setSelecteds([]);
                }
            });
        }
    }, [contact]);

    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const loadTags = async () => {
        try {
            const { data } = await api.get(`/tags/list`, 
            {params: { kanban: 0}
        });
            setTags(data);
        } catch (err) {
            toastError(err);
        }
    }

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const onChange = async (value, reason) => {
        let optionsChanged = []
        if (reason === 'create-option') {
            if (isArray(value)) {
                for (let item of value) {
                    if (item.length < 3) {
                        toastError("Tag muito curta!");
                        return;
                    }
                    if (isString(item)) {
                        const newTag = await createTag({ name: item, kanban: 0, color: getRandomHexColor() })
                        optionsChanged.push(newTag);
                    } else {
                        optionsChanged.push(item);
                    }
                }
            }
            await loadTags();
        } else {
            optionsChanged = value;
        }
        setSelecteds(optionsChanged);
        await syncTags({ contactId: contact.id, tags: optionsChanged });
    }

    function getRandomHexColor() {
        // Gerar valores aleatórios para os componentes de cor
        const red = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const green = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const blue = Math.floor(Math.random() * 256); // Valor entre 0 e 255
      
        // Converter os componentes de cor em uma cor hexadecimal
        const hexColor = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
      
        return hexColor;
    }

    return (
        <Paper className={classes.root}>
            <Autocomplete
                multiple
                size="small"
                options={tags}
                value={selecteds}
                freeSolo
                onChange={(e, v, r) => onChange(v, r)}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            variant="default"
                            className={classes.tag}
                            style={{
                                backgroundColor: option.color || '#eee',
                            }}
                            label={option.name}
                            {...getTagProps({ index })}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField {...params} className={classes.field} variant="outlined" placeholder="Tags" />
                )}
                PaperComponent={({ children }) => (
                    <Paper className={classes.optionsPaper}>
                        {children}
                    </Paper>
                )}
            />
        </Paper>
    )
}
